import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { WaveDivider } from './WaveDivider';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
  delay: number;
  isInView: boolean;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick,
  delay,
  isInView
}: FAQItemProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay
  }} className="border-b border-gray-200 last:border-0" data-id="element-32">
      <button onClick={onClick} className="w-full py-5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-[#3d7a8a] focus:ring-offset-2 rounded-lg" aria-expanded={isOpen} data-id="element-33">
        <span className="text-lg md:text-xl font-semibold text-[#0f1b2d] pr-4" data-id="element-34">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-35">
          <ChevronDownIcon className="w-6 h-6 text-[#3d7a8a]" data-id="element-36" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-37">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-38">
            <p className="pb-5 text-gray-600 leading-relaxed" data-id="element-39">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Es un libro largo?',
    answer: 'No, es una guía táctica directa al grano. Puedes leerla en un descanso.'
  }, {
    question: '¿Alguien se dará cuenta?',
    answer: 'No. Son técnicas 100% invisibles al ojo humano.'
  }, {
    question: '¿Funciona con jefes difíciles?',
    answer: 'Sí, incluye un capítulo sobre blindaje emocional ante personas tóxicas.'
  }, {
    question: '¿Es seguro el pago?',
    answer: 'Sí, utilizamos plataformas encriptadas de alta seguridad.'
  }];
  return <section className="bg-slate-50 relative" data-id="element-40">
      <div ref={ref} className="py-16 md:py-24 px-4" data-id="element-41">
        <div className="max-w-3xl mx-auto" data-id="element-42">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0f1b2d] text-center mb-12" data-id="element-43">
            Preguntas Frecuentes
          </motion.h2>

          <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8" data-id="element-44">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} delay={0.1 + index * 0.1} isInView={isInView} data-id="element-45" />)}
          </div>
        </div>
      </div>

      <WaveDivider fillColor="#0f1b2d" data-id="element-46" />
    </section>;
}